import type { Transaction } from '@api/hooks/types/getTransactions';
import type { TFunction } from 'i18next';

import type { CardConfig } from '../types';

export const getSEPAAdditionalDetailsCard = (
	operation: Transaction,
	t: TFunction,
	hasAddressAligned?: boolean,
): CardConfig => ({
	title: t('additionalDetails.title'),
	groups: [
		{
			title: t('additionalDetails.beneficiaryAddress'),
			fields: [
				{
					title: t('common.country'),
					content: operation?.beneficiary?.address?.country,
				},
				{
					title: t('common.city'),
					content: operation?.beneficiary?.address?.town,
				},
				...(hasAddressAligned
					? [
							{
								title: t('common.state'),
								content: operation?.beneficiary?.address?.country_sub_division,
							},
							{
								title: t('common.street'),
								content: operation?.beneficiary?.address?.street_name,
							},
							{
								title: t('common.buildingName'),
								content: operation?.beneficiary?.address?.building_name,
							},
						]
					: [
							{
								title: t('common.street'),
								content: operation?.beneficiary?.address?.line,
							},
						]),
				{
					title: t('common.buildingNumber'),
					content: operation?.beneficiary?.address?.building_number,
				},
				{
					title: t('common.postalCode'),
					content: operation?.beneficiary?.address?.postal_code,
				},
			],
		},
		{
			fields: [
				{
					title: t('additionalDetails.beneficiaryIdType'),
					content: operation?.beneficiary?.id?.type
						? t(
								`additionalDetails.IDOptions.${operation?.beneficiary?.id?.type?.toLocaleLowerCase()}`,
							)
						: null,
				},
				{
					title: t('additionalDetails.beneficiaryId'),
					content: operation?.beneficiary?.id?.value,
				},
			],
		},
		{
			title: t('additionalDetails.ultimateBeneficiary'),
			fields: [
				{
					title: t('common.name'),
					content: operation?.ultimate_beneficiary?.name,
				},
				{
					title: t('common.iban'),
					content: operation?.ultimate_beneficiary?.account_number,
				},
			],
		},
		{
			title: t('additionalDetails.ultimateBeneficiaryAddress'),
			fields: [
				{
					title: t('common.country'),
					content: operation?.ultimate_beneficiary?.address?.country,
				},
				{
					title: t('common.city'),
					content: operation?.ultimate_beneficiary?.address?.town,
				},
				...(hasAddressAligned
					? [
							{
								title: t('common.state'),
								content: operation?.ultimate_beneficiary?.address?.country_sub_division,
							},
							{
								title: t('common.street'),
								content: operation?.ultimate_beneficiary?.address?.street_name,
							},
							{
								title: t('common.buildingName'),
								content: operation?.ultimate_beneficiary?.address?.building_name,
							},
						]
					: [
							{
								title: t('common.street'),
								content: operation?.ultimate_beneficiary?.address?.line,
							},
						]),
				{
					title: t('common.buildingNumber'),
					content: operation?.ultimate_beneficiary?.address?.building_number,
				},
				{
					title: t('common.postalCode'),
					content: operation?.ultimate_beneficiary?.address?.postal_code,
				},
			],
		},
		{
			fields: [
				{
					title: t('additionalDetails.ultimateBeneficiaryIdType'),
					content: operation?.ultimate_beneficiary?.id?.type
						? t(
								`additionalDetails.IDOptions.${operation.ultimate_beneficiary.id.type.toLowerCase()}`,
							)
						: null,
				},
				{
					title: t('additionalDetails.ultimateBeneficiaryId'),
					content: operation?.ultimate_beneficiary?.id?.value,
				},
			],
		},
	],
});
